var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline custom-checkbox"},[_c('i',{staticClass:"far",class:{'fa-check-square text-yellow': _vm.isChecked, 'fa-square text-muted': !_vm.isChecked},on:{"click":function($event){_vm.isChecked = !_vm.isChecked}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }